import React, { useState, useEffect } from "react";
import { useUser } from '../UserContext';
import "./index.css";

const normalizarParaDigitacao = (texto) => {
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, "");
};

const normalizarTexto = (texto) => normalizarParaDigitacao(texto).trim();

export default function ModalProdutos({ produtos, onClose, onProdutoSalvo }) {
  const [busca, setBusca] = useState("");
  const { userInfo } = useUser();
  const [produtoEdit, setProdutoEdit] = useState(null); // null | "novo" | objeto
  const [ncmList, setNcmList] = useState([]);
  const [confirmarExclusao, setConfirmarExclusao] = useState(false);

  const credenciais = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  const listaFiltrada = produtos.filter(
    (p) =>
      p.proDescricao?.toLowerCase().includes(busca.toLowerCase()) ||
      String(p.proCodBarras).includes(busca) ||
      String(p.proId).includes(busca)
  );

  useEffect(() => {
    const fetchNcm = async () => {
      try {
        const response = await fetch(`${userInfo.url}/subgrupomarca`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "empresa": userInfo.alias,
            Authorization: `Basic ${credenciais}`,
          },
        });

        if (!response.ok) {
          console.error("Erro ao buscar NCM:", response.status, await response.text());
          return;
        }

        const ncmData = await response.json();
        setNcmList(ncmData);
      } catch (error) {
        console.error("Erro ao buscar NCM:", error);
      }
    };

    fetchNcm();
  }, [userInfo, credenciais]);

  const salvarProduto = async (produto) => {
    if (produto.proDescricao.trim() === "" || produto.proVlrVenda === "" || produto.embId === "" || produto.ncmId === "") {
      alert("Todos os campos são obrigatórios.");
      return;
    }

    const descricaoNormalizada = normalizarTexto(produto.proDescricao);

    let response;
    try {
      const url = produto.proId
        ? `${userInfo.url}/produto/${produto.proId}`
        : `${userInfo.url}/produto`;

      const method = produto.proId ? "PUT" : "POST";

      response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "empresa": userInfo.alias,
          Authorization: `Basic ${credenciais}`,
        },
        body: JSON.stringify({
          "PRO_DESCRICAO": descricaoNormalizada,
          "EMB_ID": Number(produto.embId),
          "PRO_VLR_VENDA": Number(produto.proVlrVenda),
          "NCM_ID": Number(produto.ncmId),
          "PRO_COD_BARRAS": produto.proCodBarras,
          "PRO_TIPO_SUBSTITUIDO": produto.proTipoSubstituido === "T" ? "T" : "F"
        }),
      });

      if (!response.ok) {
        console.error("Erro ao salvar produto:", response.status, await response.text());
        return;
      }
    } catch (error) {
      console.error("Erro ao salvar produto:", error);
      return;
    }

    await onProdutoSalvo();
    setProdutoEdit(null);
  };

  const excluirProduto = async (proId) => {
    if (!proId) {
      console.error("ID do produto não fornecido para exclusão.");
      return;
    }

    try {
      const response = await fetch(`${userInfo.url}/produto/${proId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "empresa": userInfo.alias,
          Authorization: `Basic ${credenciais}`,
        },
      });

      if (!response.ok) {
        console.error("Erro ao excluir produto:", response.status, await response.text());
        return;
      }

      await onProdutoSalvo();
      setProdutoEdit(null);
      setConfirmarExclusao(false);
    } catch (error) {
      console.error("Erro ao excluir produto:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <h3>
            {produtoEdit
              ? produtoEdit === "novo"
                ? "Novo Produto"
                : "Editar Produto"
              : "Produtos"}
          </h3>
          <div className="modal-header-actions">
            {!produtoEdit && (
              <button className="btn-add" onClick={() => setProdutoEdit("novo")}>
                +
              </button>
            )}
            <button className="btn-close" onClick={onClose}>
              ✕
            </button>
          </div>
        </div>

        {!produtoEdit ? (
          <>
            <input
              className="modal-search"
              placeholder="Buscar produto..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
            <ul className="modal-lista">
              {listaFiltrada.map((p) => (
                <li key={p.proId} onClick={() => setProdutoEdit(p)}>
                  <span>{p.proId} - {p.proDescricao}</span>
                  <small>R$ {Number(p.proVlrVenda).toFixed(2)}</small>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <FormProduto
            produto={produtoEdit === "novo" ? {} : produtoEdit}
            ncmList={ncmList}
            onCancelar={() => {
              setProdutoEdit(null);
              setConfirmarExclusao(false);
            }}
            onSalvar={salvarProduto}
            onExcluir={excluirProduto}
            confirmarExclusao={confirmarExclusao}
            setConfirmarExclusao={setConfirmarExclusao}
          />
        )}
      </div>
    </div>
  );
}

function FormProduto({
  produto,
  ncmList,
  onCancelar,
  onSalvar,
  onExcluir,
  confirmarExclusao,
  setConfirmarExclusao,
}) {
  const [form, setForm] = useState({
    proId: produto.proId || null,
    proDescricao: produto.proDescricao || "",
    proVlrVenda: produto.proVlrVenda || "",
    embId: produto.embId || "",
    proCodBarras: produto.proCodBarras || "",
    ncmId: produto.ncmId || "",
    proTipoSubstituido: produto.proTipoSubstituido || null,
  });

  const handleChange = (campo, valor) =>
    setForm((f) => ({ ...f, [campo]: valor }));

  const isEdicao = !!form.proId;

  return (
    <div className="modal-form">
      <label>Nome</label>
      <input
        required
        value={form.proDescricao}
        onChange={(e) => handleChange("proDescricao", normalizarParaDigitacao(e.target.value))}
      />

      <label>Valor de Venda</label>
      <input
        required
        type="number"
        value={form.proVlrVenda}
        onChange={(e) => handleChange("proVlrVenda", e.target.value)}
      />

      <label>Embalagem</label>
      <select
        required
        value={form.embId}
        onChange={(e) => handleChange("embId", e.target.value)}
      >
        <option value="">Selecione uma embalagem</option>
        <option value="1">Unidade - UN</option>
        <option value="2">Quilograma - KG</option>
        <option value="3">Caixa - CX</option>
        <option value="4">Metro Linear - ML</option>
        <option value="5">Metro Cubico - M3</option>
        <option value="6">Metro Quadrado - M2</option>
        <option value="7">kit - KIT</option>
        <option value="8">Peça - PC</option>
      </select>

      <label>Código de Barras</label>
      <input
        required
        value={form.proCodBarras}
        onChange={(e) => handleChange("proCodBarras", e.target.value)}
      />

      <label>NCM</label>
      <select
        required
        value={form.ncmId}
        onChange={(e) => handleChange("ncmId", e.target.value)}
      >
        <option value="">Selecione um NCM</option>
        {ncmList.map((n) => (
          <option key={n.ncmId} value={n.ncmId}>
            {n.ncmCodigo}
          </option>
        ))}
      </select>
      <div className="tipo">
        <label>
          <input
            type="checkbox"
            checked={form.proTipoSubstituido === "T"}
            onChange={(e) => handleChange("proTipoSubstituido", e.target.checked  ? "T" : "F")}
          />
          Produto com Substituição Tributária
        </label>
      </div>

      <div className="modal-form-actions">
        {isEdicao ? (
          <button className="btn-delete" onClick={() => setConfirmarExclusao(true)}>
            Excluir
          </button>
        ) : (
          <span />
        )}

        <div className="modal-form-actions-right">
          <button className="btn-cancel" onClick={onCancelar}>
            Cancelar
          </button>
          <button className="btn-save" onClick={() => onSalvar(form)}>
            Salvar
          </button>
        </div>
      </div>

      {confirmarExclusao && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>
              Tem certeza que deseja excluir o produto{" "}
              <strong>{form.proDescricao}</strong>?
            </p>
            <div className="confirm-actions">
              <button
                className="btn-cancel"
                onClick={() => setConfirmarExclusao(false)}
              >
                Cancelar
              </button>
              <button
                className="btn-delete"
                onClick={() => onExcluir(form.proId)}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}